
import React from 'react'
import HobnobModal from 'src/components/common/HobnobModalV2/HobnobModal'
import styles from './no-urls-allowed-modal.scss'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { hideNoUrlsAllowedModal } from 'src/actions/frontend'
import { noUrlsAllowedModalVisibleSelector } from 'src/selectors'
import Button from 'components/common/Button'

const NoUrlsAllowedModal = ({ visible, onHideModal }) => (
  <HobnobModal
    visible={visible}
    onCancel={onHideModal}
  >
    <div className={styles['no-urls-allowed-info-container']}>
      <div className={styles['no-urls-allowed-info-title']}>
        No URLs Allowed
      </div>
      <div className={styles['no-urls-allowed-info-text']}>
        Hobnob does not allow Custom URLs in invitations per our No Spam policy.
      </div>
      <Button key="ok" className={styles['no-urls-allowed-info-button']} onClick={onHideModal}>
        OK
      </Button>
    </div>
  </HobnobModal>
)

NoUrlsAllowedModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onHideModal: PropTypes.func.isRequired
}

function mapStateToProps(state) {
  return {
    visible: noUrlsAllowedModalVisibleSelector(state)
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onHideModal: () => dispatch(hideNoUrlsAllowedModal())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NoUrlsAllowedModal)
